<template>
	<div>
		<div class="row">
			<div class="col-md-12">			
                <div class="mb-3"> 
                    <!--type="border-card"-->  
                    <el-tabs v-model="tabIndex" @tab-click="handleTabClick">
                        <el-tab-pane :label="item.label" :name="item.index" v-for="(item, index) in tabList" :key="index" >
                            <FuelReportTab :tabIndex="item.index" :tabName="item.name" :tabLabel="item.label" style="margin-top: -15px;"/>
                        </el-tab-pane>
                    </el-tabs>
                </div>			
			</div>
		</div>
	</div>
</template>

<script>

import Bright from '@/components/page/Bright.js'
import FuelReportTab from '@/views/pages/FuelReportTab.vue'

export default
{
	extends: Bright,
	components: { 
		FuelReportTab,
	},

	data(){
		return {
			tabIndex: this.$route.query.tab ? this.$route.query.tab : '4', 
			tabList:[
				//{label:'Sales', name: 'sales', index: '0' },
				//{label:'Losses', name: 'losses', index: '1' },
				//{label:'Payment', name: 'payment', index: '2' },
				//{label:'Stock', name: 'stock', index: '3' },
				{label:'Growth By Month', name: 'growth_by_month', index: '4' },
				{label:'Growth By Year', name: 'growth_by_year', index: '5' },
				{label:'Sales Contribution', name: 'sales_contribution', index: '6' },
				{label:'RKAP vs Realisasi', name: 'rkap_vs_realisasi', index: '7' },
				//{label:'Growth Outlet', name: 'outlet', index: '8' },
			],
		}
	},
	watch:
	{
		//area() { this.resumePilihan() },
	}, 
    mounted()
    {
        this.$emit('childrenRoute');
    },
    methods:{
		handleTabClick(tab, event) {
            let tabIndex = tab.$vnode.key
            let tabName = tab.name
            let tabLabel = tab.label
			/*
            this.tab.index = tabIndex
            this.tab.name = tabName
            this.tab.label = tabLabel
			*/
        },

    }
}
</script>
<style>

.fade-enter-active, .fade-leave-active {
  opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}


</style>